<template>
  <div class="not-found d-flex flex-column align-items-center justify-content-center">
    <h2 class="not-found__title mb-3">{{ $t('error404') }}</h2>
    <h1 class="not-found__message text-primary mb-4">{{ $t('oops') }}!</h1>
    <p>{{ $t('weCouldntFindWhatYoureLookingFor') }}</p>
    <router-link :to="isScanAndGoMode ? '/scan' : '/'" class="btn btn-outline-primary">{{
      $t('returnHome')
    }}</router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'NotFound',
  computed: {
    ...mapGetters({
      isScanAndGoMode: 'user/isCustomerModeScan',
    }),
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.not-found {
  min-height: rem(500px);
}
.not-found__title {
  font-size: $font-size-3xl;
}
.not-found__message {
  font-size: $font-size-7xl;
}
</style>
